import { Pipe, PipeTransform } from '@angular/core';
import { dateTimeISORegEx } from '../util/date-util';
import * as moment from 'moment';

@Pipe({
  name: 'stringDate'
})
export class StringDatePipe implements PipeTransform {
  transform(value: any): string {
    if (value instanceof Date) {
      return moment(value).toVisibleDateTimeFormat();
    } else if (dateTimeISORegEx.test(value)) {
      return moment(value).toVisibleDateTimeFormat();
    } else return value;
  }
}
